import './Intro.css';

function Intro({ content }) {
  return (
    <section className="intro" id="intro">
      <div className="intro__content">
        <p className="eyebrow">Portfolio</p>
        <p className="intro__greeting">{content.greeting}</p>
        <h1 className="intro__name">{content.name}</h1>
        <p className="intro__role">{content.role}</p>
        <p className="intro__description">{content.description}</p>
        <nav className="intro__actions" aria-label="Portfolio sections">
          {content.navigation.map((item) => (
            <a className={`button ${item.primary ? 'button--primary' : ''}`} href={`#${item.target}`} key={item.target}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
}

export default Intro;
